Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "group-list-item54313743",
  {"root":"group-list-item54313743--root","groupImage":"group-list-item54313743--groupImage","groupName":"group-list-item54313743--groupName","groupInfo":"group-list-item54313743--groupInfo","membersInfo":"group-list-item54313743--membersInfo","actionButton":"group-list-item54313743--actionButton"},
  "",
  3,
  "group-list-item54313743"
);

